import { render } from "./CheckoutDetail.vue?vue&type=template&id=71a13dc8&scoped=true"
import script from "./CheckoutDetail.vue?vue&type=script&lang=js"
export * from "./CheckoutDetail.vue?vue&type=script&lang=js"

import "./CheckoutDetail.vue?vue&type=style&index=0&id=71a13dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a13dc8"]])

export default __exports__